type ResumeInfo = {
  position: string;
  employer: string;
  year: string;
  description: string[];
};

const workExperience: ResumeInfo[] = [
  {
    position: "C++ Software Engineer",
    employer: "Dassault Systemes",
    year: "June 2025 - Present",
    description: [
      "Refactor legacy C++ code to improve maintainability and support transition to new incoming architecture",
      "Develop automated unit and regression tests in C++/shell, expanding coverage and preventing production regressions",
      "Debug and resolve user and QA reported defects, improving app stability and reducing performance failure rates",
      "Author technical documentation to support onboarding and cross-team collaboration"
    ],
  },
  {
    position: "Fullstack Software Engineer Intern",
    employer: "Onset-LICOR",
    year: "Summer 2024",
    description: [
      "Developed an MQTT protocol handler to enable seamless communication between IoT devices and a cloud-based network",
      "Built a firmware file editing tool for developers to efficiently upload, edit, and manage JSON configurations in a NoSQL database",
      "Led full integration of Leaflet & GIS APIs into an interactive, customizable map interface, allowing users to visualize devices alongside real-time weather data",
    ],
  },
  {
    position: "Head Teaching Assistant",
    employer: "Brown University",
    year: "Nov 2023-May 2024",
    description: [
      "Led Brown’s only UI/UX design & implementation course, overseeing curriculum development with instructors",
      "Managed hiring, organization, and mentorship of 14 undergraduate teaching assistants",
      "Coordinated course logistics, ensuring smooth operations for 100+ students and staff",
    ],
  },
  {
    position: "Community Coordinator",
    employer: "Brown University",
    year: "Aug 2022-May 2024",
    description: [
      "Organized 12+ community initiatives within Brown's residential halls",
      "Assisted 90+ students in building social connections and accessing university resources",
      "Promoted a respectful and engaging living environment through community events and support",
    ],
  },
  {
    position: "Frontend Software Engineer Intern",
    employer: "Onset",
    year: "Summer 2023",
    description: [
      "Worked on engineering team for frontend and middleware development of a pilot database & IoT device management web app",
      "Delivered multiple user stories in an Agile environment, ensuring seamless functionality",
      "Collaborated with developers & product managers to refine the product through iterative design decisions",
    ],
  },
  {
    position: "Undergraduate Teaching Assistant",
    employer: "Brown Computer Science Dept.",
    year: "Fall 2022",
    description: [
      "Supported 400+ students in Java-based project design, development, and debugging",
      "Guided students through core programming concepts to foster learning and engagement",
      "Encouraged problem-solving skills and a passion for coding"
    ],
  },
];

export {workExperience}